<script setup>
import { defineProps } from "vue"
import { Gems } from "@/gems"
import RatingScale from "@/components/RatingScale.vue"
import BaseSelect from "./BaseSelect.vue";

const props = defineProps({
  elem: {
    type: Object,
    default: Object
  },
  validationLabel: {
    type: [Array, Object],
    default: Array
  },
  ratingStore: {
    type: Object,
    default: Object
  },
  validate: {
    type: Object,
    default: Object
  }
})

</script>

<template>
  <div v-if="!props.validate.isMobile.value && !props.validate.isLowerThanMobile.value">

    <div class="list-item">
      <span></span>
      <span>Data Pedido</span>
      <span>Classificação</span>
      <span>Validador(a)</span>
      <span>Validação</span>
      <span>Data Validação</span>
    </div>
          
    <div class="list-item" v-for="(history, hi) in props.elem.history" :key="hi">

      <div>
        <i class="bi bi-file-text-fill" v-if="history.with_certification" @mouseenter="Gems.Tooltip($event.target, 'Pedido com certificado', 'tooltip')"></i>
      </div>

      <div class="text-center line-clamp line-clamp-2 cursor-default"> {{ history.request_date.split(' ')[0] }} <br/> {{ history.request_date.split(' ')[1] }}</div>

      <!-- <span class="span-elem line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, props.elem.sitemap, 'tooltip tooltip-left')">
          {{ history.designation }}
      </span> -->
      
      <span class="radios n-radios">
        <RatingScale :rating-data="props.ratingStore" :element="history" :mobile-view="false" :validate-skills="true"/>
      </span>

      <span class="line-clamp line-clamp-1" @mouseenter="Gems.TooltipIfNeeded($event.target)">
        <base-select v-model="history.selectedValidatorId" v-if="history.validators_count > 1">
          <option value="">Escolha um validador...</option>
          <option v-for="(validator, vi) in history.validators" :value="validator.validator_id" :key="vi">{{ validator.validator_name}}</option>
        </base-select>

        <span v-else>
          {{ history.validators[history.selectedValidatorId].validator_name }}
        </span>
      </span>

      <span class="line-clamp line-clamp-2 cursor-default" @mouseenter="Gems.TooltipIfNeeded($event.target)">
        {{ history.selectedValidatorId
          ? props.validationLabel[history.validators[history.selectedValidatorId].validation]
          : 'Escolha um(a) validador(a)' }}
          <i class="bi bi-file-earmark-text-fill" v-if="history.selectedValidatorId" @mouseenter="Gems.Tooltip($event.target, history.validators[history.selectedValidatorId].files_list, 'tooltip tooltip-left')"></i>
      </span>

      <span class="line-clamp line-clamp-2 cursor-default" @mouseenter="Gems.TooltipIfNeeded($event.target)">
        <span v-if="history.selectedValidatorId">
          {{ history?.validators[history?.selectedValidatorId]?.validation_date.split(' ')[0] }} 
            <br/> 
          {{ history?.validators[history?.selectedValidatorId]?.validation_date.split(' ')[1] }}
        </span>
        <span v-else>
          Escolha um(a) validador(a)
        </span>
      </span>
    </div>
  </div>

  <div v-else>
    <div class="list-items">
      <div class="row align-items-center p-2 m-0">
        <span class=""></span>
        <span class="col-2 p-0 fw-bold">Data Pedido</span>
        <span class="col-6 p-0 fw-bold text-center">Classificação</span>
        <span class="col-3 p-0 fw-bold text-center">Validador(a)</span>
        <span class="col-1"></span>
      </div>
    </div>

    <div class="list-items" v-for="(history, hi) in props.elem.history" :key="hi">
      <div class="row align-items-center p-2 m-0">
        
        <span class="col-2 p-0">
          {{ history.request_date.split(' ')[0] }} <br/> {{ history.request_date.split(' ')[1] }}
        </span>
            
        <span class="col-6 p-0 sm-radios">
          <RatingScale :rating-data="props.ratingStore" :element="history" :mobile-view="true" :validate-skills="true"/>
        </span>

        <span class="col-3 p-0 text-center line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, props.elem.sitemap, 'tooltip tooltip-left')">
          <base-select v-model="history.selectedValidatorId" v-if="history.validators_count > 1">
            <option value="">Escolha um validador...</option>
            <option v-for="(validator, vi) in history.validators" :value="validator.validator_id" :key="vi">{{ validator.validator_name}}</option>
          </base-select>

          <span v-else>
            {{ history.validators[history.selectedValidatorId].validator_name }}
          </span>
        </span>

        <span class="col-1 p-0 text-end d-flex justify-content-between">
          <div>
            <i class="bi bi-file-text-fill" v-if="history.with_certification" @mouseenter="Gems.Tooltip($event.target, 'Pedido com certificado', 'tooltip')"></i>
          </div>
          <i class="bi bi-chevron-down cursor-pointer" :class="{'bi-chevron-up': history.showDetail}" @click="history.showDetail = !history.showDetail"></i>
        </span>
      </div>

      <div class="row element-detail p-2 m-0 small" v-show="history.showDetail">
        <div class="col-6 p-0">
          <div class="text-uppercase fw-bold">Decisão</div>
          <div>
            {{ history.selectedValidatorId
              ? props.validationLabel[history.validators[history.selectedValidatorId].validation]
              : 'Escolha um(a) validador(a)' }}
          </div>
        </div>

        <div class="text-end col-6 p-0">
          <div class="text-uppercase fw-bold">Data</div>
          <span>
            {{ history.selectedValidatorId
              ? history?.validators[history?.selectedValidatorId]?.validation_date
              : 'Escolha um(a) validador(a)' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import './assets/styles/validate-skills.css';

.list-item select {
  width: 100%;
  font-size: .9em;
  background-color: transparent;
  text-align: center;
}

.list-item {
  grid-template-columns: 1% 16% 34% 16% 16% 16%;
}

.list-item {
  display: grid;
  text-align: center;
  align-items: center;
  gap: .2%;
  padding: 5px;
  margin-bottom: 1px;
  min-height: 40px;
}

.div-first-column {
  display: flex;
  gap: 3%;
}

.span-elem {
  text-align: left;
  cursor: default;
}

.div-radios div {
  gap: 10px; 
}

.div-radios div input {
  transform: scale(1.3);
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

@media screen and (max-width: 1200px) {
  .list-item {
    grid-template-columns: 2% 14% 33% 20% 15% 15%;
  }

  .div-inner-rating-scale {
    height: 19px;
  }

  .radios {
    display: grid;
    grid-template-columns: 25% 25% 25%;
    row-gap: 1px;
    font-size: 1em;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios div {
    padding: 1px;
  }
}

@media screen and (max-width: 700px) {
  .list-item,
  .div-admin-filter {
    font-size: .85em;
  }

  .div-admin-filter {
    gap: 5px;
  }
}

@media screen and (max-width: 600px) {
  .sm-radios {
    display: flex;
  }

  .sm-radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .input-small-padding {
    padding: 0px !important;
  }
}

@media screen and (max-width: 450px) {
  .sm-radios {
    display: grid;
    grid-template-columns: 25% 25% 25%;
    row-gap: 1px;
    margin-left: 5%;
    margin-right: -5%;
  }

  .sm-radios :deep(> .div-rating-frame:nth-child(3)) {
    border-top-right-radius: 25px !important;
    border-bottom-right-radius: 25px !important;
    overflow: hidden !important;
  }

  .sm-radios :deep(> .div-rating-frame:nth-child(4)) {
    border-top-left-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    overflow: hidden !important;
  }
}
</style>